import React, { useEffect, useMemo, useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { CorperateEmailSettingContainerStyled } from "./styled";
import { portalService } from "apiServices";
import { ROUTE_PATH } from "utils/constants/routePath";
import { CORPERATE_EMAIL_GROUPS } from "components/Forms/CorperateEmailSettingForm";
import { Displays, Forms } from "components";

const CorperateEmailSettingContainer = () => {
  const navigate = useNavigate();
  const authenRedux = useSelector((state) => state.authenRedux);
  const permission = authenRedux?.permission?.find(
    (e) => e.menu_key === "corperate"
  );
  const [_isLoading, _setIsLoading] = useState(true);
  const [_isBgLoading, _setIsBgLoading] = useState(false);
  // เก็บรายการจาก DB ไว้เทียบตอนบันทึก { [group key]: [{ _id, email }] }
  const [_initialValues, _setInitialValues] = useState();

  // ฟอร์ม reset ทุกครั้งที่ initialValues เปลี่ยน reference จึงต้อง memo ไว้
  const _formValues = useMemo(
    () =>
      _initialValues &&
      CORPERATE_EMAIL_GROUPS.reduce((result, e) => {
        result[e.key] = _initialValues[e.key].map((f) => ({ email: f.email }));
        return result;
      }, {}),
    [_initialValues]
  );

  useEffect(() => {
    _fetchData();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const _fetchData = async () => {
    let resArr = await Promise.all(
      CORPERATE_EMAIL_GROUPS.map((e) =>
        portalService.GET_BOOKING_EMAIL_CONFIG_LIST(
          `?pagination=false&event_type=${e.event_type}&sort=created_at`
        )
      )
    );
    _setInitialValues(
      CORPERATE_EMAIL_GROUPS.reduce((result, e, i) => {
        result[e.key] =
          resArr[i] && resArr[i].status === 200 ? resArr[i].data.docs : [];
        return result;
      }, {})
    );
    _setIsLoading(false);
    _setIsBgLoading(false);
  };

  const _handleSubmit = async (values) => {
    const actionList = CORPERATE_EMAIL_GROUPS.reduce((result, group) => {
      const currentList = _initialValues[group.key] || [];
      const currentEmails = currentList.map((e) => e.email);
      const inputEmails = [
        ...new Set((values[group.key] || []).map((e) => e.email.trim())),
      ];
      inputEmails
        .filter((email) => !currentEmails.includes(email))
        .forEach((email) =>
          result.push(() =>
            portalService.POST_BOOKING_EMAIL_CONFIG_DETAIL({
              email,
              event_type: group.event_type,
            })
          )
        );
      currentList
        .filter((e) => !inputEmails.includes(e.email))
        .forEach((e) =>
          result.push(() =>
            portalService.DELETE_BOOKING_EMAIL_CONFIG_DETAIL(e._id)
          )
        );
      return result;
    }, []);
    if (actionList.length === 0) {
      toast.info("ไม่มีการเปลี่ยนแปลง");
      return;
    }
    _setIsBgLoading(true);
    let resList = await Promise.all(actionList.map((action) => action()));
    const failCount = resList.filter((res) => !res || res.status !== 200)
      .length;
    if (failCount === 0) {
      toast.success("บันทึกสำเร็จ");
    } else {
      toast.error(`บันทึกไม่สำเร็จ ${failCount} รายการ`);
    }
    _fetchData();
  };

  return (
    <CorperateEmailSettingContainerStyled>
      <Displays.BGLoading visible={_isBgLoading} />
      {_isLoading ? (
        <Displays.Loading theme_standard_loading />
      ) : (
        <Forms.CorperateEmailSettingForm
          initialValues={_formValues}
          permission={permission}
          onCancel={() => navigate(ROUTE_PATH.CORPERATE_LIST)}
          onSubmit={_handleSubmit}
        />
      )}
    </CorperateEmailSettingContainerStyled>
  );
};

export default CorperateEmailSettingContainer;
